import i18n from 'i18next'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import { apiRoutes } from './app/modules/shared/routing'

i18n
  .use(initReactI18next)
  .use(HttpBackend)
  .init({
    backend: {
      loadPath: apiRoutes.translation,
    },
    react: {
      useSuspense: false,
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
